<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">FocusON</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideCancel]="true"
				[hideDelete]="true"
				(onSaveChange)="onSave()"
				[saveDisabled]="!changesToSave"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView *ngIf="venuePayDevicePreferences">
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'mobile']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">ON Devices</div>
			</ng-template>
			<app-on-device-list [(licenseList)]="licenseList" [(onDeviceSelected)]="onDeviceSelected"></app-on-device-list>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'mobile-android']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Configuration</div>
			</ng-template>
			<div class="p-grid">
				<div class="p-col-12 p-md-6 d-flex flex-column">
					<div class="d-flex w-100">
						Show Survey after payment
						<div class="ms-auto">
							<p-inputSwitch [(ngModel)]="venuePayDevicePreferences.showSurvey" (onChange)="changesToSave = true"></p-inputSwitch>
						</div>
					</div>
					<div class="d-flex w-100">
						Server Pay Mode (all devices)
						<div class="ms-auto">
							<p-inputSwitch [(ngModel)]="venuePayDevicePreferences.serverPay" (onChange)="changesToSave = true"></p-inputSwitch>
						</div>
					</div>
					<div class="d-flex w-100">
						Sort by POS Canvas Order
						<div class="ms-auto">
							<p-inputSwitch [(ngModel)]="venuePayDevicePreferences.canvasSort" (onChange)="changesToSave = true"></p-inputSwitch>
						</div>
					</div>
					<div class="d-flex w-100">
						Print Credit Voucher
						<div class="ms-auto">
							<p-inputSwitch [(ngModel)]="venuePayDevicePreferences.printCreditVoucher" (onChange)="changesToSave = true"></p-inputSwitch>
						</div>
					</div>
				</div>
				<div class="p-col-12 p-md-6">
					<div class="d-flex w-100 flex-wrap flex-column">
						Default Employee
						<p-dropdown
							[options]="employeeList"
							optionLabel="NickName"
							optionValue="ID"
							name="employeeList"
							[virtualScroll]="true"
							virtualScrollItemSize="30"
							filter="true"
							filterBy="LastName,FirstName,NickName"
							[(ngModel)]="venuePayDevicePreferences.defaultEmployeeId"
							styleClass="w-100"
							appendTo="body"
						></p-dropdown>
					</div>
					<div class="d-flex w-100 flex-wrap">
						Printed Receipt & Voucher Footer
						<input
							pInputText
							type="text"
							id="printedReceiptFooter"
							name="printedReceiptFooter"
							[(ngModel)]="venuePayDevicePreferences.printedReceiptFooter"
							class="w-100"
							(change)="changesToSave = true"
						/>
					</div>
					<div class="d-flex w-100 flex-column">
						Printed Receipt Logo
						<img
							*ngIf="venueService.subscriptionVenue.value.key"
							class="mx-auto"
							width="200"
							height="auto"
							[src]="
								'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
								venueService.subscriptionVenue.value.key +
								'/on-receipt-logo.png?' +
								timestamp
							"
							onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/logo.jpg'"
						/>
						<p-button pRipple styleClass="p-button-raised mt-2 ms-auto" (click)="selectImage('onPrintedReceiptLogo')">
							<ng-template pTemplate="content">
								<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
								Edit Logo
							</ng-template>
						</p-button>
					</div>
				</div>
			</div>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'hand-holding-heart']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Tip Settings</div>
			</ng-template>
			<div class="p-grid">
				<div class="p-col">
					<ng-template pTemplate="header">
						<div class="d-flex">
							<div class="h3 mx-4 mt-2 mb-1">Tip Suggestions</div>
						</div>
						<p-divider></p-divider>
					</ng-template>
					<div class="p-grid">
						<div class="p-col-12 p-md-6 d-flex flex-column">
							<div class="d-flex w-100">
								Display Tip Prompt
								<div class="ms-auto">
									<p-inputSwitch
										styleClass="ms-auto my-auto"
										[(ngModel)]="venuePayDevicePreferences.promptTip"
										(onChange)="changesToSave = true"
									></p-inputSwitch>
								</div>
							</div>
							<div class="d-flex w-100">
								Display Tip Suggestions
								<div class="ms-auto">
									<p-inputSwitch
										styleClass="ms-auto my-auto"
										[(ngModel)]="venuePayDevicePreferences.displayTipSuggestions"
										(onChange)="changesToSave = true"
									></p-inputSwitch>
								</div>
							</div>
						</div>
						<div class="p-col-12 p-md-6 d-flex flex-column">
							<div class="p-grid">
								<div class="p-col-12 p-md-6">
									<span class="p-float-label mt-4 w-100">
										<p-inputNumber
											#intelligentTipThresholdInput
											[disabled]="!venuePayDevicePreferences.displayTipSuggestions"
											[(ngModel)]="venuePayDevicePreferences.tipDollarThreshold"
											mode="currency"
											currency="USD"
											locale="en-US"
											inputStyleClass="p-text-right"
											(onInput)="changesToSave = true"
											styleClass="my-auto w-100"
										></p-inputNumber>
										<label for="intelligentTipThresholdInput">Intelligent Tip Threshold</label>
									</span>
								</div>
							</div>
							<div class="p-grid">
								<div class="p-col-12 p-md-6">
									<span class="p-float-label mt-4">
										<p-inputNumber
											#tip1Percent
											[disabled]="!venuePayDevicePreferences.displayTipSuggestions"
											[(ngModel)]="venuePayDevicePreferences.tip1"
											suffix=" %"
											inputStyleClass="p-text-right"
											(onInput)="changesToSave = true"
											styleClass="w-100"
										></p-inputNumber>
										<label for="tip1Percent">Tip Suggestion 1 %</label>
									</span>
								</div>
								<div class="p-col">
									<span class="p-float-label mt-4">
										<p-inputNumber
											#tip1Dollar
											[disabled]="!venuePayDevicePreferences.displayTipSuggestions || !venuePayDevicePreferences.tipDollarThreshold"
											[(ngModel)]="venuePayDevicePreferences.tipDollar1"
											mode="currency"
											currency="USD"
											locale="en-US"
											inputStyleClass="p-text-right"
											styleClass="w-100"
											(onInput)="changesToSave = true"
										></p-inputNumber>
										<label for="tip1Dollar">Tip Suggestion 1 $</label>
									</span>
								</div>
							</div>
							<div class="p-grid">
								<div class="p-col-12 p-md-6">
									<span class="p-float-label mt-4">
										<p-inputNumber
											#tip1Percent
											[disabled]="!venuePayDevicePreferences.displayTipSuggestions"
											[(ngModel)]="venuePayDevicePreferences.tip2"
											suffix=" %"
											inputStyleClass="p-text-right"
											(onInput)="changesToSave = true"
											styleClass="w-100"
										></p-inputNumber>
										<label for="tip1Percent">Tip Suggestion 2 %</label>
									</span>
								</div>
								<div class="p-col">
									<span class="p-float-label mt-4">
										<p-inputNumber
											#tip1Dollar
											[disabled]="!venuePayDevicePreferences.displayTipSuggestions || !venuePayDevicePreferences.tipDollarThreshold"
											[(ngModel)]="venuePayDevicePreferences.tipDollar2"
											mode="currency"
											currency="USD"
											locale="en-US"
											inputStyleClass="p-text-right"
											styleClass="w-100"
											(onInput)="changesToSave = true"
										></p-inputNumber>
										<label for="tip1Dollar">Tip Suggestion 2 $</label>
									</span>
								</div>
							</div>
							<div class="p-grid">
								<div class="p-col-12 p-md-6">
									<span class="p-float-label mt-4">
										<p-inputNumber
											#tip1Percent
											[disabled]="!venuePayDevicePreferences.displayTipSuggestions"
											[(ngModel)]="venuePayDevicePreferences.tip3"
											suffix=" %"
											inputStyleClass="p-text-right"
											(onInput)="changesToSave = true"
											styleClass="w-100"
										></p-inputNumber>
										<label for="tip1Percent">Tip Suggestion 3 %</label>
									</span>
								</div>
								<div class="p-col">
									<span class="p-float-label mt-4">
										<p-inputNumber
											#tip1Dollar
											[disabled]="!venuePayDevicePreferences.displayTipSuggestions || !venuePayDevicePreferences.tipDollarThreshold"
											[(ngModel)]="venuePayDevicePreferences.tipDollar3"
											mode="currency"
											currency="USD"
											locale="en-US"
											inputStyleClass="p-text-right"
											styleClass="w-100"
											(onInput)="changesToSave = true"
										></p-inputNumber>
										<label for="tip1Dollar">Tip Suggestion 3 $</label>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</p-tabPanel>
	</p-tabView>
</div>

<app-on-device-setup *ngIf="onDeviceSelected" [(onDevice)]="onDeviceSelected"></app-on-device-setup>
